"use strict";
/* eslint-disable */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var Logger = /** @class */ (function () {
    function Logger(id) {
        this.id = id;
        this.color = null;
        this.isEnabled = null;
    }
    Logger.use = function (sink) {
        Logger.sink = sink;
    };
    Logger.configure = function (values) {
        Object.assign(this.configuration, values);
    };
    Logger.get = function (id) {
        return new Logger(id);
    };
    Object.defineProperty(Logger.prototype, "enabled", {
        get: function () {
            return !!this.isEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Logger.prototype.log = function () {
        var objs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            objs[_i] = arguments[_i];
        }
        if (this.shouldLog()) {
            var msg = objs.map(function (x) { return typeof (x) === 'string' ? x : JSON.stringify(x); }).join(' ');
            Logger.sink.log("%c ".concat(msg), "color: ".concat(this.color));
        }
    };
    Logger.prototype.warn = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        if (this.shouldLog()) {
            (_a = Logger.sink).warn.apply(_a, __spreadArray([], __read(data), false));
        }
    };
    Logger.prototype.error = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        if (this.shouldLog()) {
            (_a = Logger.sink).error.apply(_a, __spreadArray([], __read(data), false));
        }
    };
    Logger.prototype.shouldLog = function () {
        var _a;
        if (this.isEnabled !== null)
            return this.isEnabled;
        var settings = (_a = Logger.configuration[this.id]) !== null && _a !== void 0 ? _a : false;
        settings = Array.isArray(settings) ? settings : [settings, 'black'];
        this.isEnabled = settings[0];
        this.color = settings[1];
        return this.shouldLog();
    };
    Logger.configuration = {};
    Logger.sink = console;
    return Logger;
}());
exports.Logger = Logger;
